module.exports = require("@ember/object");